import React, { memo } from "react";
import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 10000,
    color: "#fff",
  },
}));

const BackdropComponent = memo(() => {
  const loading = useSelector((state) => state.loading);
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={!!loading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
});

export default BackdropComponent;